export default __webpack_public_path__ + "static/media/kitchen-1.7e7dfb4d.jpg";